// @flow
import { getFormsToConvert } from 'api/forms'
import Loading from 'components/Loading'
import * as React from 'react'
import type { FormCreationRequest } from 'types/form-creation-request'
import Badge from 'ui/atoms/Badge'
import Table from 'ui/atoms/Table'

function ConvertFormList(): React.Node {
  const [formList, setFormList] = React.useState<Array<FormCreationRequest>>([])
  const [loading, setLoading] = React.useState(false)

  React.useEffect(() => {
    async function init() {
      setLoading(true)
      const formList = await getFormsToConvert()
      setLoading(false)
      setFormList(
        formList.sort((a, b) => Number(b.pending) - Number(a.pending))
      )
    }
    init()
  }, [])

  if (loading) return <Loading skipLogoutMessage fullHeight={false} />

  if (!formList.length) return null

  return (
    <Table>
      <Table.Head columns={['Name', 'Status']} />
      <Table.Body>
        {formList.map((form) => (
          <Table.Row key={form.id}>
            <Table.Column>{form.name}</Table.Column>
            <Table.Column>
              {form.pending ? (
                <Badge $warning text="In Progress" />
              ) : (
                <Badge $success text="Completed" />
              )}
            </Table.Column>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  )
}

export default ConvertFormList
